var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 4C21 2.89543 20.1045 2 19 2H4.99996C3.8954 2 2.99996 2.89543 2.99996 4V6C2.99996 6.55228 3.44772 7 4 7C4.55228 7 5 6.55228 5 6C5 5.99717 4.99999 5.99434 4.99996 5.99151V4H19V20H4.99996V18.0085C4.99999 18.0057 5 18.0028 5 18C5 17.4477 4.55228 17 4 17C3.44772 17 3 17.4477 3 18L2.99996 20C2.99996 20.0897 2.99928 20.1779 2.9986 20.2645C2.99096 21.244 2.98506 22 3.99996 22H19C20.1045 22 21 21.1046 21 20V4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70711 7.70711L6.41421 11H15C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13H6.41421L9.70711 16.2929C10.0976 16.6834 10.0976 17.3166 9.70711 17.7071C9.31658 18.0976 8.68342 18.0976 8.29289 17.7071L3.29289 12.7071C2.90237 12.3166 2.90237 11.6834 3.29289 11.2929L8.29289 6.29289C8.68342 5.90237 9.31658 5.90237 9.70711 6.29289C10.0976 6.68342 10.0976 7.31658 9.70711 7.70711Z",
    fill: "currentColor"
  })));
};
export default SvgLogout;